import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ShieldCheck } from "lucide-react";

interface GCCPrivacyPopupProps {
  isOpen: boolean;
  onConfirm: () => void;
}

const GCCPrivacyPopup: React.FC<GCCPrivacyPopupProps> = ({
  isOpen,
  onConfirm,
}) => {
  const [showMoreInfo, setShowMoreInfo] = useState(false);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 px-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            dir="rtl"
            className="w-full max-w-sm rounded-3xl p-6 text-center shadow-xl"
            style={{ backgroundColor: "#F5EFE6" }}
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
          >
            <div
              className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full"
              style={{ backgroundColor: "#E9DFCE" }}
            >
              <ShieldCheck className="h-7 w-7" style={{ color: "#8A7357" }} />
            </div>

            <p
              className="mb-4 text-base leading-relaxed"
              style={{ color: "#4A3F35" }}
            >
              خصوصيتك محفوظة 100٪. لا أحد يستطيع رؤية محادثاتك أو الوصول
              إليها. كل شيء يبقى بينك وبين مساحتك الهادئة.
            </p>

            {showMoreInfo && (
              <p
                className="mb-4 text-sm leading-relaxed"
                style={{ color: "#6B5D4F" }}
              >
                محادثاتك مشفّرة ولا يتم مشاركتها مع أي طرف ثالث. لا يمكن لأي
                شخص، بما في ذلك فريقنا، الاطلاع على تفاصيل محادثاتك الشخصية.
              </p>
            )}

            <div className="flex flex-col gap-2">
              <button
                onClick={onConfirm}
                className="w-full rounded-xl py-3 font-semibold text-white transition hover:opacity-90"
                style={{ backgroundColor: "#8A7357" }}
              >
                تم
              </button>
              {!showMoreInfo && (
                <button
                  onClick={() => setShowMoreInfo(true)}
                  className="w-full rounded-xl py-2 text-sm font-medium transition hover:opacity-80"
                  style={{ color: "#8A7357" }}
                >
                  اعرف أكثر
                </button>
              )}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default GCCPrivacyPopup;
